/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyStripeIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-stripe" */ './utils').then((m) => m.StripeIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/stripe/icon' },
);

const LazyStripeSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-stripe-search-result" */ './utils').then(
			(m) => m.StripeSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/stripe/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const StripeIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyStripeIconComponent />
	</Suspense>
);

export const StripeSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyStripeSearchResultIconComponent />
	</Suspense>
);
